var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-100 min-h-screen pb-7"},[(_vm.isLoggedIn)?_c('TheHeader'):_vm._e(),_c('router-view'),_c('AlertGroup'),_c('portal-target',{attrs:{"name":"destination"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }